import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryGrid() {
  const displayCategories = categories.slice(1, 9);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">漫画分类</h2>
            <p className="text-sm text-foreground-500 mt-1">探索不同类型的韩漫作品</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2.5 p-5 md:p-6 bg-background-100 hover:bg-primary-50 rounded-lg transition-all duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-700 whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}